import wealth from "constants/wealth";
import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from 'html-react-parser';
import '../personal.css';
import outline_check from 'assets/images/outline_check.svg';
import EnquiryForm from "components/forms/EnquiryForm";
import { LinkButton } from "components/buttons";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

function SafeDepositBox() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron badgeText="Wealth Management" title={`<span className="jumbotron-subtitle-2">Safe Deposit Box</span>-<em>i</em>`} buttonText="Talk to us" />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{wealth.safeDepositBox.about.title}</h2>
            </Col>
            <Col md={8}>
              {parse(wealth.safeDepositBox.about.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{wealth.safeDepositBox.benefits.title}</h2>
            </Col>
            <Col md={8}>
            <div className="features-container flex-wrap">
              {wealth.safeDepositBox.benefits.description.map((benefit, index) => <div className="benefits-card" style={{ flexBasis: '30%'}} data-aos="fade-right" data-aos-delay={`${index + 1}00`}>{parse(benefit)}</div>)}
            </div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{wealth.safeDepositBox.features.title}</h2>
            </Col>
            <Col md={8}>
            <div>
              {wealth.safeDepositBox.features.description.map((eligibilty, index) => (
                <div className="eligibility-list" data-aos="zoom-in-down" data-aos-delay={`${index + 1}00`}>
                  <img src={outline_check} width="16" alt="outline_check"/>
                  <div>{parse(eligibilty)}</div>
                </div>
              ))}
            </div>
            </Col>
          </Row>
          <Row className="my-5 pt-5">
            <Col md={4}>
              <h2>{parse(wealth.safeDepositBox.rates.title)}</h2>
            </Col>
            <Col md={8}>
            </Col>
          </Row>
          {wealth.safeDepositBox.rates.branches.map((branch) => 
            <Row className="my-5">
              <Col md={4}>
                <span className="text-black-50">{parse(branch.branch)}</span>
              </Col>
              <Col md={8}>
                <img src={branch.table} alt={branch.branch} width="100%" />
              </Col>
            </Row>
          )}
          <Row>
            <Col md={4}></Col>
            <Col md={8}>
            <div className="d-flex flex-row flex-wrap gap-3 mt-5">
              <LinkButton text="Terms and Conditions" onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/TnC_SDB_10042020.pdf`)} />
            </div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>Let's connect!</h2>
              <span className="text-black-50">Share your information, and we'll get back to you with the answers you need.</span>
            </Col>
            <Col md={8}>
              <EnquiryForm />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default SafeDepositBox;